/**
 * Update date: 23-05-2023
 * Screen 2032.3
 */
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import React, { createContext, useContext, useState } from 'react';

const List = React.lazy(() => import('./List'));
const ViewDetail = React.lazy(() => import('./View'));
/**
 * create context
 */
const RegisterDeliveryContext = createContext({});

RegisterDeliveryContext.displayName = 'RegisterDeliveryContext';

export const useRegisterDelivery = () => {
  return useContext(RegisterDeliveryContext);
};

const RegisterDelivery = () => {
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    ctorderId: null,
  });
  const [formSearchData, setFormSearchData] = useState<any>({
    vendorName: '',
    vendorIds: [],
    dataList: {
      orderState: [],
    },
    orderState: '',
    fromDate: new Date(),
    endDate: new Date(),
    sendDueFromDate: '',
    sendDueToDate: '',
  });

  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const value: any = {
    data,
    setData,
    modeView,
    setModeView,
    refetchData,
    formSearchData,
    setFormSearchData,
  };

  /**
   * render content
   *
   * @return {*} 
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'view':
        return <ViewDetail />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <RegisterDeliveryContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        {renderContent()}
      </React.Suspense>
    </RegisterDeliveryContext.Provider>
  );
};

export default RegisterDelivery;
